import { DomainSecretType } from '@pushly/models/lib/enums/domain-secret-type'

export const secretTypeLabels: Record<DomainSecretType, string> = {
    [DomainSecretType.TOKEN]: "Token",
    [DomainSecretType.JSON]: "JSON",
    [DomainSecretType.USERPASS]: "Username and password",
};